"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";

export default function projectTaxTable() {
  return {
    restrict: "A",
    template: require("../../../../../view/table.html"),
    transclude: false,
    scope: {
      selectedItem: "=?myValue",
      items: "=?myItems",
      type: "@myType",
      filters: "=?myFilters",
      ok: "=?myOk",
      isPaging: "=myPagination",
      isSearch: "=mySearching",
      isFilter: "=myFilter",
      project: "=myProject",
      edit: "=edit",
      hideNotEdit: "=hideNotEdit",
    },
    controller: [
      "$scope",
      "$routeParams",
      "$utils",
      "$uibModal",
      function ($scope, $routeParams, $utils, $modal) {
        if (!$scope.selectedItem) {
          $scope.selectedItem = {};
        }

        $scope.columns = [
          {
            name: "Год",
            data: "quarter.year",
          },
          {
            name: "Стадия проекта",
            data: "phase",
            type: "func",
            func: function (phase) {
              if (!phase) return "";
              return phase === "invest" ? "Инвестиционная" : "Эксплуатационная";
            },
          },
          {
            name: "Наименование налога",
            data: "tax.name",
          },
          {
            name: "Местный бюджет (млн руб.)",
            data: "municipalBudget",
            type: "func",
            func: ranksDivider,
          },
          {
            name: "Региональный бюджет (млн руб.)",
            data: "regionalBudjet",
            type: "func",
            func: ranksDivider,
          },
          {
            name: "Федеральный бюджет (млн руб.)",
            data: "federalBudjet",
            type: "func",
            func: ranksDivider,
          },
        ];

        $scope.searching = {
          isSearch: $scope.isSearch,
          filter: null,
        };

        $scope.pagination = {
          isPaging: $scope.isPaging,
          page: 1,
          size: $scope.isPaging ? 10 : null,
          totalPages: null,
          totalItems: null,
        };

        ($scope.refresh = function () {
          if (Array.isArray($scope.items)) {
            if ($scope.items.every((i) => !equals(i, data))) {
              $scope.selectedItem = {};
            }
          }
        })();

        $scope.toolbox = {
          buttons: {
            create: {
              show: () => $scope.edit,
              click: () => {
                $modal
                  .open({
                    template: require("../view/project-tax-modal-create.html"),
                    controller: "ProjectTaxModalCreateController",
                    size: "lg",
                    backdrop: false,
                    resolve: {
                      tax: function () {
                        return {};
                      },
                      edit: function () {
                        return $scope.edit;
                      },
                      taxes: function () {
                        return $scope.items;
                      },
                    },
                  })
                  .result.then(function (data) {
                    if (!$scope.items.some((item) => equals(item, data))) {
                      $scope.items.push(data);
                    }
                  });
              },
              disabled: () => false,
            },
            edit: {
              show: () => true,
              click: (item) => {
                $modal
                  .open({
                    template: require("../view/project-tax-modal-create.html"),
                    controller: "ProjectTaxModalCreateController",
                    size: $scope.edit ? "lg" : "md",
                    backdrop: false,
                    resolve: {
                      tax: function () {
                        return item;
                      },
                      edit: function () {
                        return $scope.edit;
                      },
                      taxes: function () {
                        return $scope.items;
                      },
                    },
                  })
                  .result.then(function (data) {
                    angular.copy(data, item);
                    angular.copy(data, $scope.selectedItem);
                  });
              },
              disabled: () => !isSelected(),
            },
            remove: {
              show: () => $scope.edit,
              click: (item) => {
                $scope.items.splice(
                  $scope.items.indexOf(
                    $scope.items.find((it) => equals(it, item))
                  ),
                  1
                );
                angular.copy({}, $scope.selectedItem);
              },
              disabled: () => !isSelected(),
            },
            refresh: {
              show: () => false,
              click: $scope.refresh,
              disabled: () => false,
            },
          },
        };

        $scope.dblClick = function (item) {
          switch ($scope.type) {
            case "table":
              $scope.toolbox.buttons.edit.click(item);
              break;
            case "select":
              $scope.ok();
              break;
          }
        };

        $scope.select = function (item) {
          if (!$scope.isSelect(item)) {
            $scope.selectedItem = item;
          } else {
            $scope.selectedItem = {};
          }
        };

        $scope.isSelect = function (item) {
          return equals($scope.selectedItem, item);
        };

        function isSelected() {
          return (
            $scope.selectedItem != null && $scope.selectedItem.quarter != null
          );
        }

        function equals(i1, i2) {
          if (i1 == null || i2 == null) {
            return false;
          }

          return (
            i1.regionalBudjet === i2.regionalBudjet &&
            i1.federalBudjet === i2.federalBudjet &&
            i1.tax != null &&
            i1.tax.id === i2.tax.id &&
            i1.quarter != null &&
            i1.quarter.id === i2.quarter.id
          );
        }

        $scope.getItems = function () {
          return $scope.items;
        };

        function ranksDivider(num) {
          return num ? num.toLocaleString() : "";
        }

        $scope.getValue = $utils.getValue;
      },
    ],
  };
}
